<template>
  <a class="content-card" :href="resource.url">
    <card-image :image="resource.image">
      <span v-if="isStateBestPractice" class="content-thumb__footer">
        <i class="mr-2 far fa-map-marker-alt"></i>
        {{ stateName }}
      </span>
    </card-image>
    <div class="w-full font-normal leading-8 flex flex-wrap py-3">
      <div class="flex-grow">
        <span :class="`content-group content-group__${contentType}`">{{ $t(`contents.groups.${contentGroup}`) }}</span>
      </div>
      <div class="hidden uppercase text-gray-800 xl:block flex-none text-right text-xs">
        <span>{{ formatedDate }}</span>
      </div>
    </div>
    <div class="text-left text-xs">
      <h3 class="content-title">
        {{ resource.title }}
      </h3>
      <div class="hidden xl:block pt-1 md:pt-3 leading-5">
        <span class="cursor-pointer hover:underline h-2">
          {{ shortenedDescription }}
        </span>
      </div>
    </div>
  </a>
</template>

<script>
import CardImage from './CardImage'

import { formatDate } from 'helpers/date'
import { camelToSnakeCase } from 'helpers/string'

export default {
  name: 'ContentCard',

  components: {
    CardImage
  },

  props: {
    resource: {
      type: Object,
      required: true
    }
  },

  computed: {
    contentType() {
      return camelToSnakeCase(this.resource.type).split('_').join('-')
    },

    contentGroup(){
      return this.resource.group.toLocaleLowerCase()
    },

    formatedDate() {
      if (this.isEvent) {
        return (this.resource.event_metadatas || {}).date_short
      } else if (this.isPublication) {
        return formatDate(this.resource.published_at, 'y')
      } else {
        return formatDate(this.resource.published_at)
      }
    },

    isEvent() {
      return this.resource.group === 'event'
    },

    isPublication() {
      const publicationGroups = ['ebook', 'infographic', 'research']

      return publicationGroups.includes(this.resource.group)
    },

    isStateBestPractice() {
      return this.resource.group === 'state_best_practice'
    },

    shortenedDescription() {
      let description = this.resource.description
      if (description.length <= 200) return description;
      return description.substr(0, description.lastIndexOf(' ', 200))+'...';
    },

    stateName() {
      return ((this.resource.metadatas || {}).state || {}).name
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'stylesheets/components/content-card';

.content-card {
  @apply bg-white;
  @apply overflow-hidden;
  @apply cursor-pointer;

  .content-title {
    @apply font-normal;
    @apply text-base;
    @apply text-gray;
    @apply leading-5;
    @apply text-left;

    &:hover {
      @apply underline;
    }

    @screen md {
      @apply text-xl;
    }

    @screen lg {
      @apply leading-7
    }
  }
}
</style>
